import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { Typography } from "Components/Base/DataDisplay";
import { Chip } from "Components/Base/DataDisplay/Chip";
import { STYLE_CHIP_MOBILE } from "../../styles";

const FilterMobileSummary = ({
  languageContext,
  hasActiveFilters,
  hitCount,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Typography variant="h3" aria-hidden="true">
        {languageContext("filter")}
      </Typography>
      {hasActiveFilters && (
        <Chip
          id="learningCatalogue-hitcount-mobile"
          sx={STYLE_CHIP_MOBILE}
          label={`${hitCount} ${languageContext("courses")}`}
        />
      )}
    </Box>
  );
};

export default FilterMobileSummary;
